import { call, put, select, fork } from 'redux-saga/effects'
import {
  add as addUserAvatar
} from '../redux/userAvatars'

const baseUrl = '/GetPicture.ashx?ProfileKey='

const loadAvatar = function * (profileKey, src) {
  const resultSrc = yield call(() => new Promise(resolve => {
    const image = document.createElement('img')
    image.onload = () => resolve(src)
    image.onerror = () => resolve(null)
    image.src = src
  }))

  yield put(addUserAvatar({
    profileKey,
    data: {
      src: resultSrc,
      isLoading: false,
      isLoaded: true
    }
  }))
}

export default function * fetchUserAvatar (action) {
  const { profileKeys } = action.payload

  const state = yield select()

  const queryProfileKeys = []

  profileKeys.forEach(profileKey => {
    const avatar = state.kanbo.userAvatars[profileKey]

    if (
      queryProfileKeys.includes(profileKey) ||
      (
        avatar && (
          avatar.isLoading || (
            avatar.isLoaded &&
            avatar.loadedTimestamp === avatar.avatarTimestamp
          )
        )
      )
    ) return

    queryProfileKeys.push(profileKey)
  })

  if (!queryProfileKeys.length) return

  yield put(addUserAvatar(queryProfileKeys.map(profileKey => {
    const avatar = state.kanbo.userAvatars[profileKey]

    return {
      profileKey,
      data: {
        loadedTimestamp: avatar ? avatar.avatarTimestamp : undefined,
        isLoading: true,
        isLoaded: false
      }
    }
  })))

  for (const profileKey of queryProfileKeys) {
    const avatar = state.kanbo.userAvatars[profileKey]

    let src = baseUrl + encodeURIComponent(profileKey)

    if (avatar && avatar.avatarTimestamp) src += '&k=' + avatar.avatarTimestamp

    yield fork(loadAvatar, profileKey, src)
  }
}
